"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Phrase Strings API Reference
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@phrase.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomMetadataDataTypeToJSON = exports.CustomMetadataDataTypeFromJSONTyped = exports.CustomMetadataDataTypeFromJSON = exports.CustomMetadataDataType = void 0;
/**
 * data type of the property
 * @export
 * @enum {string}
 */
var CustomMetadataDataType;
(function (CustomMetadataDataType) {
    CustomMetadataDataType["Boolean"] = "boolean";
    CustomMetadataDataType["Date"] = "date";
    CustomMetadataDataType["Link"] = "link";
    CustomMetadataDataType["MultiSelect"] = "multi_select";
    CustomMetadataDataType["Number"] = "number";
    CustomMetadataDataType["SingleSelect"] = "single_select";
    CustomMetadataDataType["String"] = "string";
    CustomMetadataDataType["Text"] = "text";
})(CustomMetadataDataType = exports.CustomMetadataDataType || (exports.CustomMetadataDataType = {}));
function CustomMetadataDataTypeFromJSON(json) {
    return CustomMetadataDataTypeFromJSONTyped(json, false);
}
exports.CustomMetadataDataTypeFromJSON = CustomMetadataDataTypeFromJSON;
function CustomMetadataDataTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CustomMetadataDataTypeFromJSONTyped = CustomMetadataDataTypeFromJSONTyped;
function CustomMetadataDataTypeToJSON(value) {
    return value;
}
exports.CustomMetadataDataTypeToJSON = CustomMetadataDataTypeToJSON;
